enum HeightUnit {
  Feet = "ft",
  Centimeters = "cm",
}

const heightToggle = {
  name: "heightUnit",
  titleLocation: "hidden",
  type: "boolean",
  labelTrue: HeightUnit.Centimeters,
  valueTrue: HeightUnit.Centimeters,
  labelFalse: HeightUnit.Feet,
  valueFalse: HeightUnit.Feet,
  defaultValue: HeightUnit.Feet,
};

const heightInputTemplate = {
  type: "text",
  inputType: "number",
  titleLocation: "left",
};

const heightRaw = {
  ...heightInputTemplate,
  name: "heightRaw",
  isRequired: true,
  title: "{heightUnit}",
  placeholder: `Height in feet`,
  visibleIf: `{heightUnit} = ${HeightUnit.Feet}`,
  validators: [
    {
      type: "numeric",
      minValue: 3,
      maxValue: 300,
      text: "Please enter a valid number of {heightUnit}.",
    },
  ],
};

const heightRawCm = {
  ...heightInputTemplate,
  name: "heightRaw",
  isRequired: true,
  title: "{heightUnit}",
  placeholder: `Height in centimeters`,
  visibleIf: `{heightUnit} = ${HeightUnit.Centimeters}`,
  validators: [
    {
      type: "numeric",
      minValue: 3,
      maxValue: 300,
      text: "Please enter a valid number of {heightUnit}.",
    },
  ],
};

const heightInches = {
  ...heightInputTemplate,
  name: "heightInches",
  startWithNewLine: true,
  visibleIf: `{heightUnit} = ${HeightUnit.Feet}`,
  title: "in",
  placeholder: "Height in inches",
  validators: [
    {
      type: "numeric",
      minValue: 0,
      maxValue: 12,
      text: "Please a valid number of inches.",
    },
  ],
};

const heightQuestion = {
  type: "multipletext",
  name: "height",
  title: 'What is your <div class="highlight">height</div>?',
  description:
    "This helps us spot trends across thousands of users on similar journeys.",
  elements: [],
};

export {
  heightInches,
  heightQuestion,
  heightRaw,
  heightRawCm,
  heightToggle,
  HeightUnit,
};
